import { render, staticRenderFns } from "./RetailerSettings.vue?vue&type=template&id=3073100e"
import script from "./RetailerSettings.vue?vue&type=script&lang=js"
export * from "./RetailerSettings.vue?vue&type=script&lang=js"
import style0 from "./RetailerSettings.vue?vue&type=style&index=0&id=3073100e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports